<template>
  <v-hover v-slot:default="{ hover }">
    <v-card color="blue5" tile :elevation="hover ? 8 : 0" :href="href" @click="handleClick()">
      <v-card-title class="subtitle-2">
        <span style="overflow:none;text-overflow:ellipsis;">{{ contact.data }}</span>
        <v-spacer />
        <v-icon v-if="contact.displayName && contact.displayName !== ''" class="blue3--text pr-1">mdi-account-box</v-icon>
        <v-icon v-if="icon" class="blue3--text">{{ icon }}</v-icon>
        <span v-else class="blue3--text">{{ contactType }}</span>
      </v-card-title>
      <v-card-subtitle>
        <div v-if="contact.displayName && contact.displayName !== ''">
          {{ contact.displayName }}
        </div>
        {{ contactType }}
        <span v-if="contact.description && contact.description !== ''"> - {{ contact.description }}</span>
      </v-card-subtitle>
    </v-card>
  </v-hover>
</template>

<style>

</style>

<script>
export default {
  name: 'Contact',
  props: {
    contact: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      hover: false,
      contactTypes: {
        0: 'Unknown',
        1: 'Home Phone',
        2: 'Work Phone',
        3: 'Cell Phone',
        4: 'Other Phone',
        5: 'Message Phone',
        6: 'Pager Phone',
        7: 'Fax',
        8: 'Home Email',
        9: 'Work Email',
        10: 'Other Email',
        11: 'Social Media',
        103: 'Website',
        104: 'Other Website',
        105: 'Client Website'
      }
    };
  },
  computed: {
    contactType: function () {
      if ((this.contact || null) === null) return 'Unknown Contact';
      return `${this.contactTypes[this.contact.contactType]}`;
    },
    icon: function () {
      if ((this.contact || null) === null) return null;
      if ([1, 2, 4, 5, 6].includes(this.contact.contactType)) { // Non-Cell Phone
        return 'mdi-phone';
      } else if (this.contact.contactType === 3) { // Cell Phone
        return 'mdi-message-outline';
      } else if ([8, 9, 10].includes(this.contact.contactType)) { // Email
        return 'mdi-email';
      } else return null;
    },
    href: function () {
      if ([1, 2, 3, 4, 5, 6].includes(this.contact.contactType)) {
        return `tel:${this.contact.data}`;
      } else if ([8, 9, 10].includes(this.contact.contactType)) {
        return `mailto:${this.contact.data}`;
      } else return false;
    }
  },
  methods: {
    handleClick: function () {
      if ([1, 2, 3, 4, 5, 6].includes(this.contact.contactType)) {
        this.$emit('clicked', 'call');
      } else if ([8, 9, 10].includes(this.contact.contactType)) {
        this.$emit('clicked', 'email');
      }
    }
  }
};
</script>
